module.exports = __webpack_public_path__ + "static/media/CDKSpinner.92e36efe.gif";